import type { PaletteOptions } from '@mui/material'

import { colors } from './design-tokens'

/**
 * MUI Theme Palette
 *
 * Imports all colors from design-tokens for consistency.
 * This ensures MUI theme and Tailwind config use the same color values.
 */
export const themePalette = {
  mode: 'dark',
  ...colors,
} satisfies PaletteOptions
